export default "__VITE_ASSET__5jJI7mXw__"